export const SplitButtonStorageKey = {
    TEMPLATE_CREATE: 'split-btn:template-create',
    PERK_CREATE: 'split-btn:perk-create'
} as const;

export type SplitButtonStorageKey = (typeof SplitButtonStorageKey)[keyof typeof SplitButtonStorageKey];

export function getSplitButtonSelection(key: SplitButtonStorageKey): string | null {
    return localStorage.getItem(key);
}

export function setSplitButtonSelection(key: SplitButtonStorageKey, id: string): void {
    localStorage.setItem(key, id);
}
